module.exports = __webpack_public_path__ + "static/media/valor_cuota_16px.f94b9698.svg";